import { Button as MButton } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useState } from "react";
import { Notification } from "src/utils/Notification";

import { usePostApi } from "../../../hooks";
import { createPdfHead } from "../../../mock/createPdfHead";
import { getPdfSize } from "../../../pages/Reports/Report/Report.utils";
import { Button } from "../../shared/Button/Button";
import { getSnapshotPdf } from "./HistoricalSnapshotPDF.utils";

interface Props {
  listRef: React.RefObject<HTMLDivElement>;
  lbname?: string;
  scale?: number;
}

const HistoricalSnapshotPDFButton = ({ listRef, lbname, scale }: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { post } = usePostApi();
  const handleGetPdfData = async () => {
    if (!listRef.current) return;
    setIsLoading(true);

    try {
      const { body, orientation } = getSnapshotPdf(listRef.current);
      const fileData = await post({
        request: "create-pdf",
        body: {
          params: {
            head: createPdfHead,
            body,
            name: `Latest_Entries_${lbname ?? "Logbook"}`,
            scale: scale ?? 0.75,
            ...getPdfSize(orientation),
          },
        },
      });

      if (window.api) {
        window.api.downloadFile(
          fileData.file,
          ({ full, path }) => {
            notifications.show({
              title: "Report Downloaded",
              message: (
                <div>
                  <MButton
                    variant="subtle"
                    size="compact-sm"
                    onClick={() => {
                      if (window.api) window.api.openFile(full);
                    }}>
                    Open File
                  </MButton>
                  <MButton
                    variant="subtle"
                    size="compact-sm"
                    onClick={() => {
                      if (window.api) window.api.openFile(path);
                    }}>
                    Open Folder
                  </MButton>
                </div>
              ),
            });
          },
          "reports",
        );
      } else {
        window.open(fileData.file, "_blank");
      }
    } catch (e) {
      console.error(e);
      Notification("Error", "Failed to generate PDF", "red");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button onClick={handleGetPdfData} loading={isLoading} variant="outline">
      Generate PDF
    </Button>
  );
};

export default HistoricalSnapshotPDFButton;
